module.exports = __webpack_public_path__ + "static/whu-14f251d31ca577543bdc109f8a7093a6.png";